import { styled, TextV1, Stack, ButtonV2 } from '@withjoy/joykit';

export const StyledTitle = styled(TextV1)`
  font-family: 'Akkurat LL', sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.005em;
`;

export const StyledPrice = styled(TextV1)`
  color: ${props => props.theme.colors.typeTertiaryDark};
  font-family: 'Akkurat LL', sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0em;
`;

const DEFAULT_IMAGE = 'https://withjoy.com/assets/public/apps/registry/custom-item-default.svg';

export const StyledPhoto = styled.div<{ photoUrl?: string }>`
  background-image: ${({ photoUrl }) => `url(${photoUrl || DEFAULT_IMAGE})`};
  width: 100%;
  height: 328px;
  background-size: 100%;
  background-repeat: no-repeat;
  margin-bottom: 40px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-position: center center;
`;

export const StyledStack = styled(Stack)`
  align-items: center;
`;

export const StyledButton = styled(ButtonV2)`
  width: 220px;
`;
